import { MutationTree } from 'vuex';
import { PostState } from '@/store/types/post.state';

export const mutations: MutationTree<PostState> = {
    setPosts(state, value){
        state.posts = value;
    },
    setPost(state, value){
        state.post = value;
        state.loading = false;
    },
    setPostId(state, value){
        state.postId = value;
    },
    setLoading(state, value){
        state.loading = value;
    }
};
